/* eslint-disable complexity */
import React from 'react';
import _ from 'lodash';
import MultiTaskResponse from 'react-scale/components/Task/MultiTaskResponse';
import AuditDiffTaskView from 'react-scale/components/Task/AuditDiffTaskView';
import TaskPreview from './sections/TaskPreview';
import { TaskType } from '@scale/shared-types';
import { supportsDocumentTooling } from '@scale/shared/document/util';
import { getLidarLiteLink } from 'react-scale/lib/helpers/redirectHelpers';
import { normalize } from './normalize';

const lidarliteSupportedObjectTypes = ['task', 'subtask', 'taskattempt'];

export const LookupTaskPreview: React.FC<{
  object: $FIXME;
  config: $FIXME;
  additionalText: string;
  extras: $FIXME;
  readOnly?: boolean;
  overrideHeight?: string;
}> = function ({ object, config, additionalText, extras, overrideHeight }) {
  const normalizedObject = normalize(object);
  const taskType = object.type || object.taskType;

  if (
    taskType === TaskType.LidarAnnotation ||
    taskType === TaskType.LidarSegmentation ||
    taskType === TaskType.SensorFusion ||
    taskType === TaskType.DataCollectionV2
  ) {
    const shouldUseDiffViewer = _.includes(lidarliteSupportedObjectTypes, object.__t);

    if (shouldUseDiffViewer) {
      return (
        <a
          href={getLidarLiteLink({
            sceneId: object._id,
            entrypoint: 'diff-viewer',
          })}
        >
          Open in Lidar Lite Diff Viewer
        </a>
      );
    }

    return <p>No preview available for this task type.</p>;
  }

  if (extras && extras.reviewFixDetails) {
    const responses = [];
    for (const response of [extras.reviewFixDetails].flat()) {
      responses.push(response);
      if (response.corruptions) {
        // map each corruption to a response
        for (const corruption of response.corruptions) {
          const annotations = corruption.corruptionDescription.diffs
            .map((diff: any) => {
              return [diff.originalValue, diff.corruptedValue];
            })
            .flat()
            .filter((c: any) => !!c);
          responses.push({
            name: `Corruption (${corruption.corruptionDescription.corruptionType})`,
            response: {
              annotations,
              global_attributes: {},
              links: [],
            },
          });
        }
      }
    }

    return (
      <div style={{ height: overrideHeight || '70vh', display: 'flex', flexDirection: 'column' }}>
        {additionalText && <p>{additionalText}</p>}
        <MultiTaskResponse
          config={config}
          responses={responses}
          subtask={normalizedObject.subtask || normalizedObject}
        />
      </div>
    );
  }

  if (supportsDocumentTooling(normalizedObject.type)) {
    return <AuditDiffTaskView config={config} object={normalizedObject} />;
  }

  return (
    <div style={{ height: overrideHeight || '70vh', display: 'flex', flexDirection: 'column' }}>
      {additionalText && <p>{additionalText}</p>}
      {object.response && !_.isNil(object.response.confidenceScore) && (
        <p>
          <strong>Confidence Score:</strong> {object.response.confidenceScore.toFixed(4)}
        </p>
      )}
      <TaskPreview
        object={normalizedObject}
        config={config}
        response={object.__t === 'reviewerconfidence' && normalizedObject.response}
        extras={extras}
      />
    </div>
  );
};
